<template>
  <div class="page-editor">
    <template v-if="step==1">
      <mt-header fixed title="企业注册">
        <router-link to="/" slot="left">
          <mt-button icon="back">返回</mt-button>
        </router-link>
      </mt-header>
      <mt-field label="企业名称" class="required" placeholder="请输入企业名称" v-model="entInfo.name"></mt-field>
      <mt-field label="企业代码" class="required" placeholder="请输入统一社会信用代码" v-model="entInfo.code"></mt-field>
      <mt-field label="法定代表人" class="required" placeholder="请输入法定代表人" v-model="entInfo.legalMan"></mt-field>
      <mt-field label="住所" class="required" placeholder="请输入住所" type="textarea" rows="3" v-model="entInfo.address"></mt-field>
      <mt-field label="联系人" class="required" placeholder="请输入联系人" v-model="entInfo.linkman"></mt-field>
      <mt-field label="电子邮箱" placeholder="请输入电子邮箱" v-model="entInfo.email"></mt-field>
      <mt-field label="网站地址" placeholder="请输入网站地址" v-model="entInfo.website"></mt-field>
      <mt-field
        label="经营范围"
        placeholder="请输入经营范围"
        type="textarea"
        rows="5"
        v-model="entInfo.busScope"
      ></mt-field>

      <div class="page-btn">
        <mt-button type="primary" size="large" @click.native="nextStep">下一步</mt-button>
      </div>
    </template>
    <template v-if="step==2">
      <mt-header fixed title="企业注册">
          <mt-button icon="back" slot="left" @click="step=1">上一步</mt-button>
      </mt-header>
      <p style="height:2rem;"></p>
      <mt-field label="手机号码" placeholder="请输入手机号码" v-model="entInfo.telephone"></mt-field>
      <mt-field label="密码" placeholder="请输入密码" type="password" v-model="entInfo.pwd"></mt-field>
      <mt-field label="确认密码" placeholder="请再输入一次密码" type="password" v-model="entInfo.pwdRepeat"></mt-field>

      <div class="page-btn">
        <mt-button type="primary" size="large" @click.native="saveEnt">注册</mt-button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header, MessageBox } from "mint-ui";
Vue.component(Toast.name, Toast);
Vue.component(Header.name, Header);
Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(Field.name, Field);
Vue.component(MessageBox.name, MessageBox);

export default {
  data: function() {
    return {
      entInfo: {},
      step: 1
    };
  },
  methods: {
    checkEntData() {
      if (
        !this.entInfo.name ||
        !this.entInfo.code ||
        !this.entInfo.legalMan ||
        !this.entInfo.address ||
        !this.entInfo.linkman
      ) {
        Toast("请将带星号的项目填写完整！");
        return false;
      }
      if(!/^[0-9|A-Z]{18}$/.test(this.entInfo.code)){
        Toast("请填写正确的统一社会信用代码！");
        return false;
      }
      return true;
    },
    checkPwd() {
      if(!/^1[0-9]{10}$/.test(this.entInfo.telephone)){
        Toast("请填写正确的手机号码！");
        return false;
      }
      if (!this.entInfo.pwd) {
        Toast("请输入密码！");
        return false;
      }
      if(this.entInfo.pwd.length < 6){
        Toast("密码不能低于6位！");
        return false;
      }
      if (this.entInfo.pwd != this.entInfo.pwdRepeat) {
        Toast("两次密码输入不一致！");
        return false;
      }
      return true;
    },
    nextStep() {
      if (this.checkEntData()) {
        this.step = 2;
      }
    },
    saveEnt() {
      if (!this.checkPwd()) {
        return;
      }
      let $app = this;
      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/regsiter", this.entInfo)
        .then(function(resp) {
          if (resp.body.code == 200) {
            MessageBox.alert(
              "账号注册成功！"
            ).then(function() {
              $app.$router.push("/login");
            });
          } else if (resp.body.code == 500) {
            Toast(resp.body.msg || "注册失败！");
          }
        });
    }
  }
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
.mint-cell.is-textarea .mint-cell-title {
  padding: 0.5rem !important;
}
.page-btn {
  margin-top: 2rem;
  padding: 1rem;
}
</style>